<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">To the Last Extremity</p>
<p class="half1"><span class="bold">The Battles for Charleston, 1776–1782</span></p>
<p class="aut">by Mark Maloy</p>
<div class="img_containert">
<img alt="images" src="images/half.jpg"/>
</div>
<p class="edi"><em class="italic">Dan Welch, series editor</em></p>
<p class="edi"><em class="italic">Robert Orrison, chief historian</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?3af02a50